/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Markdown_Show_LessInputs */

const en_booking_markdown_show_less = /** @type {(inputs: Booking_Markdown_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show less`)
};

const pl_booking_markdown_show_less = /** @type {(inputs: Booking_Markdown_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż mniej`)
};

/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Booking_Markdown_Show_LessInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_markdown_show_less = /** @type {((inputs?: Booking_Markdown_Show_LessInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Markdown_Show_LessInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_markdown_show_less(inputs)
	return en_booking_markdown_show_less(inputs)
});